import { isMobile } from "../bridges/BridgeServices";

export const createApiData = (
  method,
  url,
  payload = {},
  retry = 2
) => {
  return {
    method: method,
    subUrl: url,
    payload: isMobile() ? JSON.stringify(payload) : payload,
    retryCount: retry,
  };
};
